export const ageSegments = [
    'Not due',
    '< 15',
    '15-30',
    '30-60',
    '60-90',
    '90-180',
    '> 180',
]

export type AgeSegmentValue = Record<string, number>
export type AgeSegmentSum = {
    label: string
    value: number
}

export const accumulateEntriesSum = (entries: AgeSegmentValue[]): AgeSegmentSum[] => {

    const initialTotals = Object.fromEntries(ageSegments.map(segment => [segment, 0]))

    const summedTotals = entries.reduce((totals, currentItem) => {
        for (const key in currentItem) {
            totals[key] += currentItem[key]
        }
        return totals
    }, initialTotals)

    return ageSegments.map(segment => ({
        label: segment,
        value: summedTotals[segment]
    }))
}
